import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import Store from './redux/Store'
// import { GoogleOAuthProvider } from '@react-oauth/google';
import '../node_modules/react-modal-video/scss/modal-video.scss'
import { GoogleOAuthProvider } from '@react-oauth/google';

ReactDOM.render(
    <GoogleOAuthProvider clientId="128373290193-725cpssv8dv3o34c81a2vhqm6dg4a446.apps.googleusercontent.com">
        <Provider store={Store}>
            <App />
        </Provider>
    </GoogleOAuthProvider>,
    document.getElementById('root')
);
